import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

interface Props {
  title: string
  description: string
  primaryCta: StrapiLinkSharedComponent
}

function Footer({ title, description, primaryCta }: Props) {
  return (
    <section
      id="show-interest"
      className={clsx('bg-[#090909] text-white relative')}
    >
      <Image
        src="/assets/index-25/decode-bg-img.png"
        alt="decode-bg-img"
        height="955"
        width="1441"
        className="absolute w-full h-full object-top"
      />
      <div className="container | relative z-10 mx-auto py-10 md:py-18">
        <div className="mb-14 text-center">
          <h1 className="title text-4xl md:text-5xl font-medium tracking-tight | mb-5 md:mb-8">
            {title}
          </h1>
          <div
            className="text-xl md:text-2xl md:max-w-col-9 mx-auto"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        <div className="flex justify-center items-start">
          <Link
            href={primaryCta.href}
            target={primaryCta.target}
            className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] flex justify-center items-center gap-2 whitespace-nowrap text-sm font-medium rounded-lg py-2 px-10 w-full md:w-auto"
          >
            {primaryCta.title}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Footer
